// To be used when the parent of this S12nBulkPayEnrollModal is not a
// react component so handleClose can be managed automatically.
import * as React from 'react';

import S12nBulkPayEnrollModal from 'bundles/s12n-enroll/components/bulk-pay/S12nBulkPayEnrollModal';
import type { PropsFromCaller } from 'bundles/s12n-enroll/components/bulk-pay/S12nBulkPayEnrollModal';

class StandaloneEnrollModal extends React.Component<PropsFromCaller> {
  state = {
    showModal: true,
  };

  /**
   * Since this is a proxy container for ./S12nBulkPayEnrollModal.jsx, please
   * view S12nBulkPayEnrollModal to get the propTypes.
   */
  handleClose() {
    this.setState({ showModal: false });
  }

  render() {
    const props = Object.assign({}, this.props, {
      onClose: () => this.setState({ showModal: false }),
    });

    return (
      <div className="rc-StandaloneEnrollModal">{this.state.showModal && <S12nBulkPayEnrollModal {...props} />}</div>
    );
  }
}

export default StandaloneEnrollModal;
